import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";

export const app =
  !firebase.apps.length &&
  initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_JSON));
